import { io, Socket } from "socket.io-client";
import { SOCKET_URL } from "./app.config";

const getAuthToken = (): string | null => {
  return localStorage.getItem("authToken");
};

// Create AI socket connection (NO authentication required)
const aiSocket: Socket = io(`${SOCKET_URL}/ai`, {
  transports: ["websocket", "polling"],
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
});

let chatSocket: Socket | null = null;

const connectChatSocket = (token?: string): Socket | null => {
  const authToken = token || getAuthToken();

  if (!authToken) {
    console.warn("No authentication token found. Chat socket not initialized.");
    disconnectChatSocket();
    return null;
  }

  if (chatSocket && chatSocket.connected) {
    return chatSocket;
  }

  if (chatSocket) {
    chatSocket.disconnect();
  }

  chatSocket = io(`${SOCKET_URL}/chat`, {
    transports: ["websocket", "polling"],
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    auth: {
      token: authToken,
    },
  });

  chatSocket.on("connect", () => {
    console.log("Connected to Chat Socket.IO server (authenticated)");
  });

  chatSocket.on("connect_error", (error: any) => {
    console.error("Chat Socket connection error:", error);
    if (error.message.includes("Authentication error")) {
      console.error("Authentication failed for chat socket");
      disconnectChatSocket();
    }
  });

  chatSocket.on("disconnect", (reason: any) => {
    console.log("Chat Socket disconnected:", reason);
  });

  return chatSocket;
};

const getChatSocket = (): Socket | null => {
  return chatSocket;
};

const disconnectChatSocket = (): void => {
  if (chatSocket) {
    chatSocket.disconnect();
    chatSocket = null;
    console.log("Chat socket disconnected");
  }
};

aiSocket.on("connect", () => {
  console.log("Connected to AI Socket.IO server");
});

aiSocket.on("connect_error", (error: any) => {
  console.error("AI Socket connection error:", error);
});

aiSocket.on("disconnect", (reason: any) => {
  console.log("AI Socket disconnected:", reason);
});

export { aiSocket, getChatSocket, connectChatSocket, disconnectChatSocket };

export const socket = aiSocket;